import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Shield, Info } from "lucide-react";
import { imgNbaLogo } from "../../../../assets";

export default function KYCStep4() {
  const navigate = useNavigate();

  const professionalFee = 5000000;
  const platformFee = professionalFee * 0.02;
  const processingFee = 2000;
  const totalDeduction = platformFee + processingFee;
  const protectedFee = professionalFee - totalDeduction;

  const handleContinue = () => {
    navigate("/d/kyc/step5");
  };

  return (
    <div className="kyc-page">
      <div className="kyc-header">
        <div className="kyc-logo-section">
          <img className="kyc-logo-img" src={imgNbaLogo} alt="NBA Logo" />
          <div className="kyc-logo-text">
            <div className="kyc-logo-name">NIGERIAN BAR ASSOCIATION</div>
            <div className="kyc-logo-sub">REMUNERATION PORTAL</div>
          </div>
        </div>
      </div>

      <div className="kyc-progress">
        <button
          className="kyc-back-button"
          type="button"
          onClick={() => navigate("/d/kyc/step3")}
          aria-label="Go back"
        >
          <ArrowLeft size={20} />
        </button>
        <div className="kyc-progress-content">
          <span className="kyc-progress-text">Step 4 of 7</span>
          <div className="kyc-progress-bar">
            <div className="kyc-progress-fill" style={{ width: "57.1%" }} />
          </div>
        </div>
      </div>

      <div className="kyc-container">
        <div className="kyc-content">
          <div className="kyc-section-header">
            <h1 className="kyc-title">Fee Breakdown</h1>
            <p className="kyc-subtitle">
              Review professional fee and platform deduction
            </p>
          </div>

          <div className="kyc-fee-breakdown">
            <div className="kyc-fee-breakdown-item">
              <div className="kyc-fee-breakdown-left">
                <span className="kyc-fee-breakdown-label">Professional Fee</span>
                <span className="kyc-fee-breakdown-amount">
                  ₦{professionalFee.toLocaleString()}
                </span>
              </div>
              <span className="kyc-fee-breakdown-note">
                Amount shown to client
              </span>
            </div>
          </div>

          <div className="kyc-divider-label">
            <div className="kyc-divider-line" />
            <span>PLATFORM FEE</span>
            <div className="kyc-divider-line" />
          </div>

          <div className="kyc-platform-fees">
            <div className="kyc-platform-fee-item">
              <div className="kyc-platform-fee-left">
                <span className="kyc-platform-fee-label">Platform Fee (2%)</span>
                <span className="kyc-platform-fee-desc">
                  2% of ₦{professionalFee.toLocaleString()}
                </span>
              </div>
              <span className="kyc-platform-fee-amount">
                ₦{platformFee.toLocaleString()}
              </span>
            </div>

            <div className="kyc-platform-fee-divider" />

            <div className="kyc-platform-fee-item">
              <div className="kyc-platform-fee-left">
                <span className="kyc-platform-fee-label">Processing Fee</span>
                <span className="kyc-platform-fee-desc">Fixed service charge</span>
              </div>
              <span className="kyc-platform-fee-amount">
                ₦{processingFee.toLocaleString()}
              </span>
            </div>
          </div>

          <div className="kyc-total-deduction">
            <span className="kyc-total-deduction-label">
              Total Platform Deduction
            </span>
            <span className="kyc-total-deduction-amount">
              ₦{totalDeduction.toLocaleString()}
            </span>
          </div>

          <div className="kyc-divider-label">
            <div className="kyc-divider-line" />
            <span>FINAL AMOUNT</span>
            <div className="kyc-divider-line" />
          </div>

          <div className="kyc-protected-fee">
            <div className="kyc-protected-fee-header">
              <span className="kyc-protected-fee-label">
                PROTECTED FEE (TO LAWYER)
              </span>
              <div className="kyc-protected-badge">
                <Shield size={16} />
                <span>FULLY PROTECTED</span>
              </div>
            </div>
            <span className="kyc-protected-fee-amount">
              ₦{protectedFee.toLocaleString()}
            </span>
            <p className="kyc-protected-fee-desc">
              This is your final, fully protected professional fee after all
              platform deductions
            </p>
          </div>

          <div className="kyc-info-box kyc-info-box--with-icon">
            <Info size={20} />
            <p>
              The payment link/invoice to the client will display only the
              Professional Fee; platform fees are deducted after payment.
            </p>
          </div>

          <button
            className="dashboard-button dashboard-button--primary dashboard-button--large"
            type="button"
            onClick={handleContinue}
          >
            <span>Confirm & Continue</span>
          </button>
        </div>
      </div>
    </div>
  );
}

